const Selectr = require("mobius1-selectr");

const SELECTOR = ".js-searchable-select";

class SearchableSelect {
    static attach() {
        [...document.querySelectorAll(SELECTOR)].forEach((searchSelectElement) => {
            /* eslint-disable-next-line no-unused-vars */
            const searchSelect = new Selectr(searchSelectElement);
        });
    }
}

export { SearchableSelect };
